// Critical CSS first
import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { PrimeReactProvider } from 'primereact/api';
import ErrorBoundary from "./components/ErrorBoundary";

import { GlobalContextProvider } from "./contexts/global.context";
import { ErrorContextProvider } from "./contexts/error.context";
import { AuthContextProvider } from "./contexts/auth.context";
import { ProjectContextProvider } from "./contexts/new-project.context";
import { SectionProvider } from "./contexts/section.context";

// Lazy load ToastContainer and its CSS (non-critical for initial render)
const ToastContainer = React.lazy(() =>
  import("react-toastify").then(module => {
    // Dynamically load the CSS when the component is loaded
    import("react-toastify/dist/ReactToastify.css");
    return { default: module.ToastContainer };
  })
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <React.Suspense fallback={null}>
      <ToastContainer />
    </React.Suspense>
    <BrowserRouter>
      <GlobalContextProvider>
        <AuthContextProvider>
          <ErrorContextProvider>
            <SectionProvider>
              <ProjectContextProvider>
                <PrimeReactProvider>
                  <ErrorBoundary>
                    <App />
                  </ErrorBoundary>
                </PrimeReactProvider>
              </ProjectContextProvider>
            </SectionProvider>
          </ErrorContextProvider>
        </AuthContextProvider>
      </GlobalContextProvider>
    </BrowserRouter>
  </React.Fragment>
);
